import React from "react";
import { ComponentWithAs, Icon, IconProps } from "@chakra-ui/react";

const IconComp: ComponentWithAs<"svg", IconProps> = ({
  children,
  ...props
}) => {
  return (
    <Icon {...props}>
      <path
        d="M320,160H32c-17.673,0-32,14.327-32,32v288c0,17.673,14.327,32,32,32h288c17.673,0,32-14.327,32-32V192
				C352,174.327,337.673,160,320,160z M320,480H32V192h288V480z"
      />
      <path
        d="M480,0H192c-17.673,0-32,14.327-32,32v80h32V32h288v288h-80v32h80c17.673,0,32-14.327,32-32V32
				C512,14.327,497.673,0,480,0z"
      />
    </Icon>
  );
};
IconComp.defaultProps = {
  viewBox: "0 0 512 512",
  boxSize: "20px",
};

export default IconComp;
